module.exports = __webpack_public_path__ + "img/logo_2.b4d585db.jpg";